import { get } from 'lodash';
import { connect } from 'react-redux';

import Faq from 'components/Faq';
import CustomCollectionModel from 'models/CustomCollectionModel';
import FaqItemModel from 'models/FaqItem';
import { getCustomCollectionData } from 'state/selectors/collection';

const mapStateToProps = state => {
  const customCollection = new CustomCollectionModel(getCustomCollectionData(state));

  const title = get(customCollection, 'faqHeading');
  const items = get(customCollection, 'faqItems');
  const parsedItems = items?.map(itemData => {
    const fields = get(itemData, 'fields', {});
    const { question, answer } = new FaqItemModel(fields);

    return {
      question,
      answer,
    };
  });

  return {
    title,
    items: parsedItems,
  };
};

export default connect(mapStateToProps)(Faq);
